import React from "react";
import "./SummaryCard.css";

export function SummaryCard({ icon, title, children }) {
  return (
    <div className="summary-card">
      <div className="summary-card-header">
        {icon && <span className="summary-card-icon">{icon}</span>}
        <h3>{title}</h3>
      </div>
      <div className="summary-rows">{children}</div>
    </div>
  );
}

export function SummaryRow({ icon, label, value }) {
  return (
    <div className="summary-row">
      {icon && <span className="summary-row-icon">{icon}</span>}
      <div className="summary-row-text">
        <span className="summary-label">{label}</span>
        <span className="summary-value">{value || "–"}</span>
      </div>
    </div>
  );
}
